var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-semibold items-center justify-center",style:(_vm.style)},[(!_vm.isImage)?_c('span',[_vm._v(_vm._s(_vm.userInitial))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }